import Http from 'services/Http';
import sanitizeAgenticBody from './sanitizeAgenticBody';

class AgentToolApi {
  list() {
    return Http.get('/v1/tools').then(r => r.data.tools);
  }

  get(id) {
    return Http.get(`/v1/tools/${id}`).then(r => r.data.tool);
  }

  create(body) {
    return Http.post('/v1/tools', sanitizeAgenticBody(body)).then(r => r.data.tool);
  }

  update(id, body) {
    return Http.put(`/v1/tools/${id}`, sanitizeAgenticBody(body)).then(r => r.data.tool);
  }

  destroy(id) {
    return Http.delete(`/v1/tools/${id}`);
  }
}

export default new AgentToolApi();
